import { atom } from '@reatom/framework'

import { AsyncStateN, Iterable, pipe } from '@blade/std-lib'
import { CurrencyModel } from '@root/entities/currency'
import { walletsByIdAtom } from '@root/entities/wallet/atoms'
import { defaultCurrenciesAtom } from '@root/features/currency/default-currencies'

import { reatomSearchToken } from '../../search-token'

import type { WalletId } from '@root/entities/wallet'

export const reatomWalletAssetsManagement = ({
  walletId,
}: {
  walletId: WalletId
}) => {
  const {
    searchTokenAction,
    searchStateAtom: stateAtom,
    searchQueryAtom,
    setQueryAction,
  } = reatomSearchToken()

  const filteredCurrenciesAtom = atom((ctx) => {
    const defaultCurrencies = ctx.spy(defaultCurrenciesAtom)
    const wallet = ctx.spy(walletsByIdAtom).get(walletId)
    const assets = wallet ? ctx.spy(wallet.assets) : []
    const walletCurrencies = assets.map((it) => it.currency)

    const allCurrencies = pipe(
      [...defaultCurrencies, ...walletCurrencies],
      Iterable.uniqBy((it) => it.address),
      Iterable.toArray,
    )

    const searchQuery = ctx.spy(searchQueryAtom)
    const searchState = ctx.spy(stateAtom)

    if (AsyncStateN.isSuccess(searchState)) {
      return [searchState.value]
    }

    if (searchQuery) {
      return CurrencyModel.searchCurrencies(searchQuery)(allCurrencies)
    }

    return allCurrencies
  }, 'filteredCurrenciesAtom')

  return {
    searchTokenAction,
    stateAtom,
    searchQueryAtom,
    setQueryAction,
    currenciesAtom: filteredCurrenciesAtom,
  }
}
